import "./index.css";
import Home from "./pages/Home";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";

import Pnt from "./pages/projects/Pnt";
import Strathmore from "./pages/projects/Strathmore";
import Esoma from "./pages/projects/Esoma";
import DiscordFeud from "./pages/projects/DiscordFeud";
import TwoOfUs from "./pages/projects/TwoOfUs";
import ScrollToTop from "./ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route exact path="/home" element={<Home />} />
        <Route exact path="/portfolio" element={<Portfolio />} />
        <Route exact path="/contact" element={<Contact />} />

        <Route exact path="/portfolio/pnt-store" element={<Pnt />} />
        <Route exact path="/portfolio/sds" element={<Strathmore />} />
        <Route exact path="/portfolio/esoma" element={<Esoma />} />
        <Route exact path="/portfolio/discord-feud" element={<DiscordFeud />} />
        <Route
          exact
          path="/portfolio/two-of-these-people"
          element={<TwoOfUs />}
        />

        <Route exact path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
